module.exports = __webpack_public_path__ + "static/media/purchase-order_icon_blue.75830784.png";